import React, { useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AlarmsSearch from "../../components/AlarmsSearch/AlarmsSearch";
import useAlarms from "../../hooks/useAlarms";
import TotalAlarms from "../../components/TotalAlarms/TotalAlarms";
import AlarmsTable from "../../components/AlarmsTable/AlarmsTable";
import useAlarmsSearchController from "../../hooks/useAlarmsSearchController";
import {
  selectAlarmsCriteria,
  setAlarmsDateRange,
  setAlarmsSelectedLabels,
  setAlarmsCriteria,
  setAlarmsPagination,
} from "../../redux/slices/alarmsSearchSlice";
import ListExportModal from "../../components/Modals/ListExportModal/ListExportModal";
import { ListExportScope } from "../../components/Modals/ListExportModal/ListExportModal";
import { exportAlarmsData } from "../../utils/exportAlarmsUtils";

function Alarms() {
  const dispatch = useDispatch();
  const alarmsCriteria = useSelector(selectAlarmsCriteria);

  const { fetchAlarms, fetchAlarmsForExport, alarmsData, totalAlarms } =
    useAlarms(null);

  const [exportState, setExportState] = useState({
    visible: false,
    fileType: null,
  });

  const filterOptions = useMemo(
    () => [
      { label: "Temperatura", value: "tempAlarm" },
      { label: "Impacto", value: "impactAlarm" },
      { label: "Humedad", value: "humAlarm" },
      { label: "Apertura", value: "openAlarm" },
    ],
    [],
  );

  const {
    searchParameters,
    onDateChange,
    onExtraFilterChange,
    onSearch,
    onPaginateChange,
  } = useAlarmsSearchController({
    alarmsCriteria,
    dispatchRedux: dispatch,
    setAlarmsDateRange,
    setAlarmsSelectedLabels,
    setAlarmsCriteria,
    setAlarmsPagination,
    fetchAlarms,
    filterOptions,
  });

  const openExportModal = (fileType) => {
    setExportState({
      visible: true,
      fileType,
    });
  };

  const closeExportModal = () => {
    setExportState({
      visible: false,
      fileType: null,
    });
  };

  const requestExportData = async (_fileType, maxExport) => {
    return await fetchAlarmsForExport({
      startDateAlarm: searchParameters.startDateAlarm,
      endDateAlarm: searchParameters.endDateAlarm,
      tempAlarm: searchParameters.tempAlarm,
      impactAlarm: searchParameters.impactAlarm,
      openAlarm: searchParameters.openAlarm,
      humAlarm: searchParameters.humAlarm,
      maxSize: maxExport,
    });
  };

  const doExport = (data, fileType) => {
    exportAlarmsData(data, fileType);
  };

  return (
    <div className="Alarms">
      <AlarmsSearch
        onSearch={onSearch}
        onDateChange={onDateChange}
        onExtraFilterChange={onExtraFilterChange}
        filterOptions={filterOptions}
        searchParameters={searchParameters}
        selectedLabels={alarmsCriteria.selectedLabels}
      />
      {searchParameters.searchWasMade && (
        <>
          <TotalAlarms alarmsData={alarmsData} totalAlarms={totalAlarms} />
          <AlarmsTable
            alarmsData={alarmsData}
            fetchAlarms={fetchAlarms}
            searchParameters={searchParameters}
            setSearchParameters={() => {}}
            onPaginateChange={onPaginateChange}
            currentPage={searchParameters.page}
            pageSize={searchParameters.size}
            onExport={openExportModal}
          />
        </>
      )}

      <ListExportModal
        listSummary={alarmsData}
        exportState={exportState}
        onClose={closeExportModal}
        onRequestData={requestExportData}
        onExport={doExport}
        exportScope={ListExportScope.ALARMS}
      />
    </div>
  );
}

export default withTranslation()(Alarms);
